  (() => {
    const cookiePatterns = [
   /* Klaviyo */
  /^__kla_id$/,

  /* Microsoft Clarity — first-party */
  /^_clck$/,
  /^_clsk$/,

  /* Meta */
  /^_fbp$/,
  /^_fbc$/,

  /* Google Analytics and Ads */
  /^_ga$/,
  /^_ga_/,
  /^_gid$/,
  /^_gat/,
  /^_gcl_au$/,
  /^_gcl_/,

  /* Pinterest */
  /^_pin_unauth$/,

  /* Shopify Analytics */
  /^_shopify_s$/,
  /^_shopify_y$/,

  /* Snowplow Analytics */
  /^_sp_id(?:\.|$)/,
  /^_sp_ses(?:\.|$)/,

  /* TikTok */
  /^_ttp$/,
  /^ttcsid$/,
  /^ttcsid_/,
  /^ttclid$/,

  /* Bazaarvoice */
  /^BVBRANDID$/,
  /^BVBRANDSID$/,

  /* Bazaarvoice Vibe / Curalate */
  /^crl8\.fpcuid$/,

  /* OptiMonk */
  /^optiMonkClient$/i,
  /^optiMonkClientId$/i,
  /^optiMonkSession$/i,

  /* Reddit */
  /^_rdt_uuid$/,

  /* Other tracking platforms */
  /^optimizely/i,
  /^criteo/i,
  /^cto_/i,
  /^__apex_test__$/i,
  /^yotp/i
    ];

    const shouldDeleteCookie = (name) => {
      return cookiePatterns.some((pattern) => pattern.test(name));
    };

    const deleteCookie = (name) => {
      const hostname = window.location.hostname;

      const domains = [
        null,
        hostname,
        `.${hostname}`,
        'coloroops.com',
        '.coloroops.com'
      ];

      domains.forEach((domain) => {
        const domainAttribute = domain
          ? `; domain=${domain}`
          : '';

        document.cookie =
          `${name}=; Max-Age=0; path=/${domainAttribute}; SameSite=Lax`;

        document.cookie =
          `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainAttribute}`;
      });
    };

    const removeNonEssentialCookies = () => {
      document.cookie.split(';').forEach((cookie) => {
        const name = cookie.split('=')[0].trim();

        if (name && shouldDeleteCookie(name)) {
          deleteCookie(name);
        }
      });
    };

    const cleanUpIfConsentWasDenied = () => {
      const customerPrivacy = window.Shopify?.customerPrivacy;

      if (!customerPrivacy?.currentVisitorConsent) {
        return;
      }

      const consent = customerPrivacy.currentVisitorConsent();

      const analyticsDenied = consent.analytics === 'no';
      const marketingDenied = consent.marketing === 'no';

      if (analyticsDenied && marketingDenied) {
        removeNonEssentialCookies();
      }
    };

    /*
     * Runs immediately when the visitor changes consent.
     * This should execute before Pandectes reloads the page.
     */
    document.addEventListener('visitorConsentCollected', (event) => {
      const consent = event.detail || {};

      const analyticsDenied = consent.analyticsAllowed === false;
      const marketingDenied = consent.marketingAllowed === false;

      if (analyticsDenied && marketingDenied) {
        removeNonEssentialCookies();
      }
    });

    /*
     * Fallback after page reload in case the first event
     * was interrupted by the reload.
     */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        window.setTimeout(cleanUpIfConsentWasDenied, 500);
      });
    } else {
      window.setTimeout(cleanUpIfConsentWasDenied, 500);
    }
  })();
